import { MediaQueries, theme } from '@hhgtech/hhg-components'
import { Carousel } from '@hhgtech/hhg-components/mantine'
import styled from 'styled-components'

export const StyledBabyPoopDetailVideoListWrapper = styled.div`
  margin-block: 40px;
  ${MediaQueries.mbDown} {
    margin-left: -16px;
    margin-right: -16px;
  }

  &[data-slide='2'] {
    margin-block: 0;
    display: flex;
    gap: 24px;
    > div {
      width: 100%;
    }
  }
`

export const StyledCarousel = styled(Carousel)`
  .mantine-Carousel-indicators {
    top: calc(100% + 1rem);
  }

  .mantine-Carousel-indicator {
    width: 8px;
    height: 8px;
    border-width: 0;
    opacity: 1;
    background-color: ${theme.colors.neutral200};

    &[data-active] {
      background-color: #e55c8a;
    }
    .mantine-Carousel-control[data-inactive] {
      opacity: 0;
      cursor: 'default';
    }
  }
`
